angular.module("ainapp")
    .controller("payrollSettingsGradeController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Payroll Settings Grade";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.CostCenters = [];
            MainService.GetParentCostCenters().then(function (response) {
                $scope.CostCenters = response.data;
            })


            $scope.Init = function () {

                $scope.load = false;
                $scope.ViewVal = 0;


                $scope.payRoll = {
                    DebitAccountId: "",
                    CreditAccountId: "",
                }

                $scope.Grades = [];
                MainService.GradesInDropdown().then(function (response) {
                    $scope.Grades = response.data;

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    $scope.ViewVal = $scope.Grades[0].Id;
                    $scope.SelectedData = $scope.Grades[0];
                    MainService.GetPayrollSettingsGrade($scope.Grades[0].Id).then(function (response) {
                        if (response.data != null && response.data != "") {
                            $scope.payRoll = response.data;
                        } else {
                            $scope.payRoll = {
                                DebitAccountId: "",
                                CreditAccountId: "",
                            };
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    })

                }, function (err) {
                    toastr.error("Network Error");
                })



            }
            $scope.Init();

            $scope.switchTab = function (data) {
                $scope.ViewVal = data.Id;
                $scope.SelectedData = data;

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetPayrollSettingsGrade(data.Id).then(function (response) {
                    if (response.data != null && response.data != "") {
                        $scope.payRoll = response.data;
                    } else {
                        $scope.payRoll = {
                            DebitAccountId: "",
                            CreditAccountId: "",
                        };
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })
            }


            $scope.saveCostSettings = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.payRoll.GradeId = $scope.ViewVal;
                MainService.AddPayrollSettingsGrade($scope.payRoll).then(function (response) {
                    if (response.data != null && response.data != "") {
                        toastr.success("Success");
                        $scope.switchTab($scope.SelectedData);
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }




      }]);
